<template>
  <div class="full-area">
    <header class="question-header" v-if="!data.fields.questionImage.fields.file.url">
      <h2>{{data.fields.questionTitle}}</h2>
    </header>

    <header class="question-header image-question" v-if="data.fields.questionImage.fields.file.url">
      <div
        class="img"
        :style="{'backgroundImage': `url(${data.fields.questionImage.fields.file.url})`}"
      ></div>
    </header>

    <content class="content delay-entry short-delay">
      <div class="grid-wrapper extended">
        <div
          :span="12"
          v-for="option in options"
          :key="option"
          class="binary-box"
          :class="{'selected-box': form.selected[0] === option}"
          @click="selectThis(option)"
        >
          <div
            class="center-me"
            :class="`card_thumbs-${option}`"
          >
            <font-awesome-icon :icon="['fas', `thumbs-${option}`]" />
          </div>
        </div>
      </div>
    </content>
    <footer>
      <SkipQuestionButton
        :location="'locate-bottom'"
        v-on:skip="selectThis('NS/NR')"
      ></SkipQuestionButton>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Thumbs',

  props: [ 'data' ],

  components: {
    SkipQuestionButton: () => import('Components/base/SkipQuestionButton')
  },

  data () {
    return {
      options: ['down', 'up'],
      form: {
        question: this.data.fields.title,
        id: this.data.sys.id,
        selected: [],
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      }
    }
  },

  methods: {
    selectThis (item) {
      Vue.set(this.form, 'selected', [item])
    },
    next () {
      this.form.timestamps.finish = new Date()
      this.calculateScores()
      this.$emit('next', this.form)
    },
    validInput (value) {
      // Add simple validation: if it exists, it is valid.
      if (value) {
        this.form.timestamps.valid = new Date()
        this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
        return true
      } else {
        return false
      }
    },
    calculateScores () {
      if (!this.data.fields.formula) {
        return
      }
      this.$store.dispatch('CALCULATE_WEIGHTED_QUESTION', {
        formula: this.data.fields.formula,
        selected: this.form.selected,
        options: this.options,
        maxAnswers: 1
      }).then(scores => {
        this.form.weighted = scores.weighted.slice(0)
        this.form.weightedMin = scores.weightedMin
        this.form.weightedMax = scores.weightedMax
      }).catch(err => {
        console.log('err: ', err)
      })
    }
  },

  watch: {
    // Add a simple watch to trigger next automatically after some ms
    'form.selected': function (newVal, oldVal) {
      if (this.validInput(newVal)) {
        setTimeout(() => {
          console.log(this.form)
          this.next()
        }, 200)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .question-header {
    margin-bottom: 60px;

    height: 60vh;

    @include breakpoint($tablet) {
      transform: scale(0.8);
    }
  }

  .grid-wrapper.extended {
    @include breakpoint($tablet) {
      transform: scale(0.8);
      max-width: 78vw;
    }
  }

  .content {
    align-items: flex-start;

    max-height: 20vh;
    display: flex;
    flex-grow: 1;
    align-items: flex-start;
    margin-top: -4vh;

    @include breakpoint($micro) {
      margin-top: 0;
    }
    @include breakpoint($tablet) {
      align-items: flex-start;
      margin-top: -26vh;
    }
  }

  .center-me {
    display: flex;
    flex: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: center;
    align-items: center;
    color: white;
    border-radius: 5px;
    font-size: 2.5em;
  }

  .card_thumbs-up {
    background: $color-emphasis-alt;
  }
  .card_thumbs-down {
    background: $color-emphasis;
  }
</style>
